import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormsBean } from '../../common.types';

type CityFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register'>;

export const CityField = (props: CityFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('address.city', {
            required: true,
            maxLength: 50,
         })}
         label={commonTranslationKeys.city}
         placeholder={commonTranslationKeys.enterCity}
         testId={'city'}
         className={'city'}
      />
   );
};
